import { render, staticRenderFns } from "./_tabAnnexation.vue?vue&type=template&id=70bd4cc1&scoped=true&"
import script from "./_tabAnnexation.vue?vue&type=script&lang=js&"
export * from "./_tabAnnexation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd4cc1",
  null
  
)

export default component.exports